import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './bursa-api-order-result.reducer';
import { IBursaAPIOrderResult } from 'app/shared/model/bursa-api-order-result.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIOrderResult = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const bursaAPIOrderResultList = useAppSelector(state => state.bursaAPIOrderResult.entities);
  const loading = useAppSelector(state => state.bursaAPIOrderResult.loading);
  const totalItems = useAppSelector(state => state.bursaAPIOrderResult.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="bursa-api-order-result-heading" data-cy="BursaAPIOrderResultHeading">
        <Translate contentKey="comexApp.bursaAPIOrderResult.home.title">Bursa API Order Results</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="primary" outline onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="comexApp.bursaAPIOrderResult.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="comexApp.bursaAPIOrderResult.home.createLabel">Create new Bursa API Order Result</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {bursaAPIOrderResultList && bursaAPIOrderResultList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('endpointURL')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.endpointURL">Endpoint URL</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('memberShortName')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.memberShortName">Member Short Name</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('uuid')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.uuid">Uuid</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('serialNumbers')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.serialNumbers">Serial Numbers</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('forceYN')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.forceYN">Force YN</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('maxWaitTime')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.maxWaitTime">Max Wait Time</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('waitAllDoneYN')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.waitAllDoneYN">Wait All Done YN</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('bidErrNo')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.bidErrNo">Bid Err No</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('bidMsg')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.bidMsg">Bid Msg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('otcErrNo')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.otcErrNo">Otc Err No</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('otcMsg')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.otcMsg">Otc Msg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('stbErrNo')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.stbErrNo">Stb Err No</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('stbMsg')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.stbMsg">Stb Msg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('regTime')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.regTime">Reg Time</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('orderTime')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.orderTime">Order Time</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('resultTime')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.resultTime">Result Time</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('purchaseTime')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.purchaseTime">Purchase Time</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('reportTime')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.reportTime">Report Time</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('sellingTime')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.sellingTime">Selling Time</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('unit')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.unit">Unit</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.price">Price</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('totalOrderCount')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.totalOrderCount">Total Order Count</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('processingCount')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.processingCount">Processing Count</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('bursaAPIOrderId')}>
                  <Translate contentKey="comexApp.bursaAPIOrderResult.bursaAPIOrderId">Bursa API Order Id</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bursaAPIOrderResultList.map((bursaAPIOrderResult, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${bursaAPIOrderResult.id}`} color="link" size="sm">
                      {bursaAPIOrderResult.id}
                    </Button>
                  </td>
                  <td>{bursaAPIOrderResult.endpointURL}</td>
                  <td>{bursaAPIOrderResult.memberShortName}</td>
                  <td>{bursaAPIOrderResult.uuid}</td>
                  <td>{bursaAPIOrderResult.serialNumbers}</td>
                  <td>{bursaAPIOrderResult.forceYN}</td>
                  <td>{bursaAPIOrderResult.maxWaitTime}</td>
                  <td>{bursaAPIOrderResult.waitAllDoneYN}</td>
                  <td>{bursaAPIOrderResult.bidErrNo}</td>
                  <td>{bursaAPIOrderResult.bidMsg}</td>
                  <td>{bursaAPIOrderResult.otcErrNo}</td>
                  <td>{bursaAPIOrderResult.otcMsg}</td>
                  <td>{bursaAPIOrderResult.stbErrNo}</td>
                  <td>{bursaAPIOrderResult.stbMsg}</td>
                  <td>{bursaAPIOrderResult.regTime}</td>
                  <td>{bursaAPIOrderResult.orderTime}</td>
                  <td>{bursaAPIOrderResult.resultTime}</td>
                  <td>{bursaAPIOrderResult.purchaseTime}</td>
                  <td>{bursaAPIOrderResult.reportTime}</td>
                  <td>{bursaAPIOrderResult.sellingTime}</td>
                  <td>{bursaAPIOrderResult.unit}</td>
                  <td>{bursaAPIOrderResult.price}</td>
                  <td>{bursaAPIOrderResult.totalOrderCount}</td>
                  <td>{bursaAPIOrderResult.processingCount}</td>
                  <td>{bursaAPIOrderResult.bursaAPIOrderId}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${bursaAPIOrderResult.id}`} size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIOrderResult.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIOrderResult.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="comexApp.bursaAPIOrderResult.home.notFound">No Bursa API Order Results found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bursaAPIOrderResultList && bursaAPIOrderResultList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BursaAPIOrderResult;
